<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title mt-0" id="mySmallModalLabel">
                <span v-if="loadingDetail">Loading ...</span>
                <span v-else>#{{dataDetail.invoice_code}}</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
        </div>
        <div class="modal-body">
            <div class="card card-loader d-flex" v-if="loadingDetail" style="height: 50vh; background-color: transparent">
                <div class="justify-content-center">
                    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading</p>
                </div>
            </div>

            <div v-else>
                <div class="row align-items-center" style="margin-bottom: 20px">
                    <div class="col-12 col-md-9">
                        <div class="d-flex align-items-center">
                            <img v-if="$store.state.userData" :src="$store.state.userData ? $store.state.userData.company_logo : '-' " style="height: 50px" class="mr-5">
                            <table>
                                <tr>
                                    <td><b>Invoice Code</b></td>
                                    <td>: #{{ dataDetail.invoice_code }}</td>
                                </tr>
                                <tr v-if="dataDetail.payment_method == 'QRIS_STATIC'">
                                    <td><b>Ref ID / Arsip</b></td>
                                    <td>: {{ dataDetail.ref_id }}</td>
                                </tr>
                                <tr>
                                    <td><b>Tanggal Penetapan</b></td>
                                    <td>: {{ dataDetail.invoice_date }}</td>
                                </tr>
                                <tr>
                                    <td><b>Metode Pembayaran</b></td>
                                    <td>: {{ dataDetail.payment_method ? paymentMethodName(dataDetail.payment_method) : '-' }}</td>
                                </tr>
                                <tr v-if="dataDetail.is_penalty">
                                    <td><b>Periode Denda</b></td>
                                    <td>: {{ dataDetail.penalty_period_value }} {{ dataDetail.penalty_period ? convertPeriod(dataDetail.penalty_period) : '-' }}</td>
                                </tr>
                                <tr v-if="dataDetail.is_penalty">
                                    <td><b>Jumlah Denda</b></td>
                                    <td>: {{ dataDetail.penalty_nominal_type == 'PERCENTAGE' ? dataDetail.penalty_nominal_value : currency(dataDetail.penalty_nominal_value) }} {{ dataDetail.penalty_nominal_type == 'PERCENTAGE' ? '%' : '' }}</td>
                                </tr>
                                <tr v-if="dataDetail.va_no">
                                    <td><b>No ID</b></td>
                                    <td>: {{ dataDetail.customer ? dataDetail.customer.customer_code : '-' }}</td>
                                </tr>
                                <tr v-if="dataDetail.status">
                                    <td><b>Status</b></td>
                                    <td v-if="dataDetail.status == 'SUCCESS'"><span class="badge badge-success">SUKSES</span></td>
                                    <td v-else-if="dataDetail.status == 'PENDING'"><span class="badge badge-warning">MENUNGGU PEMBAYARAN</span></td>
                                    <td v-else-if="dataDetail.status == 'WAITING_PROCESS'"><span class="badge badge-primary">MENUNGGU PERSETUJUAN</span></td>
                                    <td v-else-if="dataDetail.status == 'WAITING_CONFIRMATION'"><span class="badge badge-dark">DRAFT</span></td>
                                    <td v-else><span class="badge badge-danger">EXPIRED</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="text-center">
                            <button type="button" class="btn btn-primary" @click.prevent="refreshTransaction">
                                <i class="fas fa-sync-alt"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <div class="table-responsive">
                            <table class="table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>Kategori Retribusi</th>
                                        <th class="text-right">Harga</th>
                                        <th class="text-right">Jumlah</th>
                                        <th class="text-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in dataDetail.objectRetribution" :key="item.id">
                                        <th>{{item.service_name}}</th>
                                        <td class="text-right">{{currency(item.price)}}  / {{item.unit}}{{item.unit_type}}</td>
                                        <td class="text-right">{{item.qty}}</td>
                                        <td class="text-right">{{currency(item.total)}}</td>
                                    </tr>
                                    <tr v-if="dataDetail.penalty">
                                        <th colspan="2" class="border-0"></th>
                                        <td class="border-0 font-14"><b>Denda</b></td>
                                        <td class="border-0 font-14 text-right"><b>{{currency(dataDetail.penalty.amount)}}</b></td>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="border-0"></th>
                                        <td class="border-0 font-14"><b>Total</b></td>
                                        <td class="bg-dark text-white border-0 font-14 text-right"><b>{{currency(dataDetail.total)}}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-4" v-for="item in dataDetail.qris" :key="item.id">
                        <div class="div" style="position: relative">
                            <img src="@/assets/qris-template.png" alt="" style="width: 100%">
                            <div style="position: absolute; top: 22%; left: 50%; transform: translate(-50%, -50%); width: 90%" class="text-center">
                                <p style="margin-bottom: 0px; color: #000">{{item.merchant_name}}</p>
                                <p style="margin-bottom: 0px; color: #000">NMID : {{item.nm_id}}</p>
                            </div>
                            <vue-qrcode :value="item.qr_value" tag="img" style="position: absolute; top: 62%; left: 50%; transform: translate(-50%, -50%); width: 90%"></vue-qrcode>
                            <p style="margin-bottom: 0px; color: #000; position: absolute; bottom: 6px; left: 25px;">Dicetak oleh : {{item.merchant_pan ? item.merchant_pan.substr(0, 8) : null}}</p>
                        </div>
                        <p class="text-center" style="margin-bottom: 0px; margin-top: 10px">{{currency(item.amount)}}</p>
                        <p class="text-center" style="margin-bottom: 0px;">Bill Number: {{item.bill_number}}</p>
                        <p class="text-center">Expired: {{item.expired_at}}</p>
                    </div>
                </div>
            </div>

            <hr>

            <div class="row d-flex justify-content-center">
                <a href="#" class="btn btn-primary" data-dismiss="modal">Tutup</a>
            </div>
        </div>
    </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
    components: {
        VueQrcode,
    },
    data(){
        return {
            dataDetail: null,
            loadingDetail: true
        }
    },
    methods: {
        convertPeriod(period) {
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Minggu'
            }else if(period == 'MONTHLY'){
                return 'Bulan'
            }else{
                return 'Tahun'
            }
        },
        getNoId(va) {
            if(va){
                const l = va.length
                return va.substring(6, l);
            }else{
                return '-'
            }
        },
        loadDetail(id) {
            this.loadingDetail = true
            $('#modalDetail').modal('show')
            
            this.$http.get(`${this.API_URL}transaction/${id}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                const result = response.data;
                if(result.success) {
                    this.dataDetail = result.data
                    setTimeout(() => {
                        this.loadingDetail = false;
                    }, 100);
                }else {
                    this.sAlert('error', result.message)
                    this.loadingDetail = false;
                }
            })
            .catch(error => {
                this.loadingDetail = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        refreshTransaction() {
            const id = this.dataDetail.id
            this.loadingDetail = true;

            this.$http.get(`${this.API_URL}transaction/${id}/check-payment`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            }).then(response => {
                this.$http.get(`${this.API_URL}transaction/${id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                }).then(response => {
                    const result = response.data;
                    if(result.success) {
                        this.dataDetail = result.data
                        setTimeout(() => {
                            this.loadingDetail = false;
                        }, 100);
                    }else {
                        this.sAlert('error', result.message)
                        this.loadingDetail = false;
                    }
                })
            })
            .catch(error => {
                this.loadingDetail = false;
                this.errorHandler(error)
            });
        },
    }
}
</script>

<style>

</style>